import React from 'react';
import s from './s.module.less';
import { Popover, Select, Spin, Tabs } from 'antd';
import TabPane from 'antd/es/tabs/TabPane';
import BillingInvoiceTable from '../BillingInvoiceTable';
import BillingFreeCreditsTable from '../BillingFreeCreditsTable';
import useAdStatus from 'hooks/marketing/useAdStatus';
import JoinProListings from '../JoinProListings';
import useProlistingFeeSummary from 'hooks/useProlistingFeeSummary';
import PriceLabel from 'components/PriceLabel';

const { Option } = Select;

interface Props {
    isPractice?: boolean;
}

const ProListingsInvestment = ({ isPractice = false }: Props) => {
    const [selectedPeriod, setSelectedPeriod] = React.useState(1);
    const [activeTab, setActiveTab] = React.useState<'invoices' | 'free-credits'>('invoices');
    const [adInfo] = useAdStatus();
    const [prolistingFeeSummary, prolistingFeeSummaryLoading, fetchProlistingFeeSummary] = useProlistingFeeSummary(
        selectedPeriod,
        isPractice,
    );
    const isOptionDisabled = (weeks: number): boolean => {
        return false;
        // if (!budgetInfo.createdAt) return false;

        // // 从创建时间到现在经过了多少周
        // const createdDate = new Date(budgetInfo.createdAt);
        // const now = new Date();

        // const timeDifference = now.getTime() - createdDate.getTime();
        // const oneWeekInMs = 7 * 24 * 60 * 60 * 1000;

        // const weeksSinceCreated = Math.ceil(timeDifference / oneWeekInMs);
        // return weeksSinceCreated < weeks;
    };

    const handlePeriodChange = (value: number) => {
        setSelectedPeriod(value);
    };

    if (!adInfo) {
        return <Spin />;
    }
    //todo remove
    if (!adInfo.hasJoinedAdSystem) {
        return <JoinProListings />;
    }

    return (
        <div className={s.wrap}>
            <div className={s.title}>
                <span>Pro-Listings investment</span>
                <div className={s.controls}>
                    {/* <Select
                        value={selectedPeriod}
                        onChange={(value) => setSelectedPeriod(value)}
                        className={s.select}
                        dropdownStyle={{ minWidth: '160px' }}
                    >
                        <Select.Option value={1}>Last 1 week</Select.Option>
                        <Select.Option value={2} disabled={isOptionDisabled(2)}>Last 2 weeks</Select.Option>
                        <Select.Option value={4} disabled={isOptionDisabled(4)}>Last 4 weeks</Select.Option>
                        <Select.Option value={8} disabled={isOptionDisabled(8)}>Last 8 weeks</Select.Option>
                        <Select.Option value={12} disabled={isOptionDisabled(12)}>Last 12 weeks</Select.Option>
                        <Select.Option value={0}>Since you started</Select.Option>
                    </Select> */}
                    <Select
                        value={selectedPeriod}
                        onChange={(value) => handlePeriodChange(value)}
                        className={s.select}
                        dropdownStyle={{ minWidth: '160px' }}
                    >
                        <Option value={1}>Last 1 month</Option>
                        <Option value={2}>Last 2 months</Option>
                        <Option value={3}>Last 3 months</Option>
                        <Option value={4}>Last 4 months</Option>
                        <Option value={5}>Last 5 months</Option>
                        <Option value={6}>Last 6 months</Option>
                        {/* <Option value={0}>Since you started</Option> */}
                    </Select>
                </div>
            </div>
            <div className={s.overviewSection}>
                <div className={s.overviewSectionItem}>
                    <div className={s.h}>
                        <span>Total Pro-Listings investment</span>
                        <Popover
                            trigger="hover"
                            content={
                                <div className={s.pop}>
                                    Total amount you’ve invested in Pro-Listings to promote your profile and increase
                                    patient bookings.
                                </div>
                            }
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                    stroke="#4B5563"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Popover>
                    </div>
                    <div className={s.priceWrap}>
                        <span className={s.price}>
                            <PriceLabel value={prolistingFeeSummary?.totalProListingFeeInvestment} />
                        </span>
                        {/* <span className={s.priceDesc}>
                            (includes $800 collected from Klarity)
                        </span> */}
                    </div>
                    {/* <div className={s.actions}>
                        <span>Update reimbursement
                        </span>
                    </div> */}
                </div>
                <div className={s.overviewSectionItem}>
                    <div className={s.h}>
                        <span>Free credits remaining</span>
                        <Popover
                            trigger="hover"
                            content={
                                <div className={s.pop}>
                                    The amount of free credits you have left before paid spend begins.
                                </div>
                            }
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                    stroke="#4B5563"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Popover>
                    </div>
                    <div className={s.priceWrap}>
                        <span className={s.price}>
                            ${prolistingFeeSummary?.freeCreditsRemaining}{' '}
                            <span style={{ fontSize: '12px', fontWeight: '400' }}>
                                {' '}
                                / {prolistingFeeSummary?.freeCreditsTotal}
                            </span>
                        </span>
                        <span className={s.priceDesc} />
                    </div>
                    {/* <div className={s.actions}>
                        <span>Pay now</span>
                        <span>Pay later</span>
                    </div> */}
                </div>
            </div>
            <Tabs
                activeKey={activeTab}
                onChange={(key) => {
                    setActiveTab(key as 'invoices' | 'free-credits');
                }}
            >
                <TabPane tab="Invoices" key="invoices">
                    <BillingInvoiceTable isPractice={isPractice} />
                </TabPane>
                <TabPane tab="Free credits" key="free-credits">
                    <BillingFreeCreditsTable isPractice={isPractice} />
                </TabPane>
            </Tabs>
        </div>
    );
};

export default ProListingsInvestment;
